/**
 * Activities — the interaction log against leads, opportunities and accounts.
 */
import { ResourceListPage } from "@/components/ResourceListPage";
import { formatDateTime } from "@/lib/money";
import type { ActivityRow } from "./types";

const ACTIVITY_TYPES = ["Call", "Email", "Meeting", "Note", "Demo", "Task"];
const ENTITY_TYPES = ["Lead", "Opportunity", "Customer", "Supplier"];

export function CrmActivitiesPage() {
  return (
    <ResourceListPage<ActivityRow>
      title="Activities"
      subtitle="Calls, emails and meetings logged against a lead, an opportunity or an account."
      breadcrumb={["CRM", "Activities"]}
      path="/crm/activities"
      queryKey={["crm", "activities"]}
      createLabel="Log activity"
      emptyTitle="No activity logged"
      emptyMessage="Activities are the record of who spoke to whom and when. They are what makes a handover between reps possible."
      createFields={[
        {
          field: "entityType",
          label: "Relates to",
          required: true,
          options: ENTITY_TYPES,
        },
        {
          field: "entityId",
          label: "Record ID",
          required: true,
          hint: "The id of the lead, opportunity or account this concerns.",
        },
        {
          field: "activityType",
          label: "Type",
          required: true,
          options: ACTIVITY_TYPES,
        },
        {
          field: "note",
          label: "Note",
          hint: "What was discussed, and what happens next.",
        },
      ]}
      columns={[
        {
          key: "occurred_at",
          label: "When",
          render: (r) => formatDateTime(r.occurred_at),
        },
        { key: "activity_type", label: "Type" },
        { key: "entity_type", label: "Relates to" },
        {
          key: "entity_id",
          label: "Record",
          render: (r) => (
            <span className="atlas-mono">{r.entity_id.slice(0, 8)}</span>
          ),
        },
        { key: "note", label: "Note", render: (r) => r.note ?? "—" },
      ]}
    />
  );
}
